// Navigation hook — fetches the editable mega-menu structure from /api/navigation.
// Falls back to the hardcoded defaults from constants/navigation.js if the API
// is unreachable or the document is missing, so the site never breaks.

import { useEffect, useState } from "react";
import api from "@/lib/api";
import { NAV_GROUPS as DEFAULT_NAV_GROUPS } from "@/constants/navigation";

export function useNavigation() {
  const [groups, setGroups] = useState(DEFAULT_NAV_GROUPS);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await api.get("/navigation");
        if (!cancelled && Array.isArray(r.data?.groups) && r.data.groups.length) {
          setGroups(r.data.groups);
        }
      } catch (_) {
        /* keep defaults */
      } finally {
        if (!cancelled) setLoaded(true);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  // Public site: only render visible groups + visible items
  const visibleGroups = groups
    .filter((g) => g.visible !== false)
    .map((g) => ({
      ...g,
      items: (g.items || []).filter((it) => it.visible !== false),
    }));

  return { groups, visibleGroups, loaded };
}

// Helper: resolve a nav item to a link path
export function navLinkPath(item) {
  if (item.direct) return item.slug;          // already an absolute path
  return `/p/${item.slug}`;
}
